import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SendIcon from '../assests/sendIcon.png'
import classes from './SubmissionPopup.module.css'
import { submissionsApi } from "../../../utils";
import { throwApiError } from "../store/error-handling-actions";
import BackdropPopup from "../UI/Popups/BackdropPopup/BackdropPopup";
import { ActivityTypeEnum } from "../models/ActivityTypeEnum";
import * as ideWrapper from "../../lms-shared/ide-wrapper";
import DynamicMessage from "../UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../models/DynamicMessageTypeEnum";
import { changeActiveLessonId } from "../../../store/general-actions";

const Final = ({ saveProjectCallback }) => {

    const texts = useSelector(state => state.translate.texts);

    return (
        <>
            <div className={classes.Header}>
                <img className={classes.icon} src={SendIcon} alt="SendIcon" />
                <p>{texts.submissionAssesment}</p>
            </div>
            <div className={classes.submissionPopupTitle}>{saveProjectCallback ? texts.saveAndSubmissionPopupTitle : texts.submissionPopupTitle}</div>
            <div className={classes.submissionPopupContent}>{texts.submissionPopupContent}</div>
        </>
    )
}

const Learning = () => {

    const texts = useSelector(state => state.translate.texts);

    return (
        <>
            <div className={classes.Header}>
                <p>{texts.saveAssesment}</p>
            </div>
            <div className={classes.submissionPopupTitle}>{texts.saveLearningAssessment}</div>
        </>
    )
}

const SubmissionPopup = ({ lessonParticipant, lessonId, close, assessmentId, submissionId, studyGroupId, setSuccessSubmissionPopup, saveProjectCallback, setAssesmentStatus, activityType }) => {

    const dispatch = useDispatch();
    const [message, setMessage] = useState(null)
    const user = useSelector((state) => state.auth.user);
    const [load, setLoad] = useState(false);
    const texts = useSelector(state => state.translate.texts);

    function closePopup(e) {
        e.stopPropagation()
        close()
    }

    function submit() {
        if (saveProjectCallback) {
            ideWrapper.requestChangesProject((changed) => {
                if (changed === true) {
                    saveProjectCallback(() => {
                        sendAssessment();
                    }, setLoad);
                } else {
                    sendAssessment();
                }
            });
        } else {
            sendAssessment();
        }
    }

    function sendAssessment() {
        setLoad(true)
        const data = {
            id: submissionId,
            studyGroupId
        }
        if (assessmentId)
            data.assessmentId = assessmentId;

        submissionsApi.submissionsSubmitPost({ submissionSubmitInput: data }, (error, resdata, response) => {
            if (error) {
                setLoad(false)
                if (error?.response?.body?.code == 413) {
                    setMessage(<DynamicMessage
                        type={DynamicMessageTypeEnum.Warn}
                        title={texts.LessonInEditByTeamMember}
                        showCancel={false}
                        confirmText={texts.ok}
                        confirmFunc={() => setMessage(null)} />);
                } else {
                    close()
                    dispatch(throwApiError({ userMessage: texts.MessageContentSubmissionsSubmitPost, error: error, statusCode: response?.statusCode, message: "submissionsSubmitPost " + error.message, level: 2, component: "SubmissionPopup", line: 25 }))
                }
            }
            else {
                setLoad(false)
                setAssesmentStatus && setAssesmentStatus(response.body)
                if (ActivityTypeEnum[activityType] === ActivityTypeEnum.Final) {
                    const allUserIds = lessonParticipant?.user?.users?.map(u => u.id !== user.id ? u.id : null).filter(Boolean);
                    dispatch(changeActiveLessonId(null, studyGroupId, null, allUserIds));
                }
                setSuccessSubmissionPopup()
            }
        })
    }

    return (
        <BackdropPopup>
            {load ?
                <div className={classes.Loader}></div> :
                <div className={classes.SubmissionPopupContainer}>
                    {ActivityTypeEnum[activityType] === ActivityTypeEnum.Final ?
                        <Final saveProjectCallback={saveProjectCallback} /> : <Learning />
                    }
                    <div className={classes.btnsContainer}>
                        <button className={`${classes.Btn} ${classes.BtnCancel}`} onClick={e => closePopup(e)}>{texts.cancel}</button>
                        <button className={`${classes.Btn} ${classes.BtnOk}`} onClick={submit}>{texts.ok}</button>
                    </div>
                </div>}
            {message}
        </BackdropPopup>
    )
}

export default SubmissionPopup;